/**
 * SharePoint Authentication Module  
 * Handles authentication flow for SharePoint environments
 * Delegates to sharepointDialog.js for actual implementation
 */

import { 
  handleSharePointAuth as handleSharePointAuthDialog,
  isSharePointReady as isSharePointDialogReady,
  initializeSharePoint as initializeSharePointDialog 
} from './sharepointDialog.js';

/**
 * Handle SharePoint authentication flow
 * @returns {Promise<Object>} - Authentication result
 */
export const handleSharePointAuth = async () => {
  console.log("[SHAREPOINT-AUTH] Starting SharePoint authentication flow...");
  
  try {
    // Use the implementation from sharepointDialog.js
    return await handleSharePointAuthDialog();
  } catch (error) {
    console.error("[SHAREPOINT-AUTH] ❌ SharePoint authentication error:", error.message);
    return {
      success: false,
      component: 'ServiceUnavailable',
      error: error.message,
      message: 'SharePoint authentication service unavailable'
    };
  }
};

/**
 * Check if SharePoint environment is ready for authentication
 * @returns {boolean} - Whether SharePoint is ready
 */
export const isSharePointReady = () => {
  // Use the implementation from sharepointDialog.js
  return isSharePointDialogReady();
};

/**
 * SharePoint-specific initialization
 */
export const initializeSharePoint = () => {
  console.log("[SHAREPOINT-AUTH] Initializing SharePoint environment...");
  // Use the implementation from sharepointDialog.js
  initializeSharePointDialog();
};

/**
 * Handle SharePoint login success callback
 * @param {Object} loginResult - Result from login dialog
 */
export const handleSharePointLoginSuccess = (loginResult) => {
  console.log("[SHAREPOINT-AUTH] SharePoint login successful:", loginResult);
  // Handle successful SharePoint login
  // This might involve storing tokens, updating UI, etc.
};

export default {
  handleSharePointAuth,
  isSharePointReady,
  initializeSharePoint,
  handleSharePointLoginSuccess
};
